<div class="dialog-loading" *ngIf="(loading$ | async)">
  <mat-spinner diameter="36"></mat-spinner>
</div>
<div class="dialog-title-content">
  <div class="dialog-title">{{ title() }}</div>
  <div class="dialog-close" (click)="closeDialog(false)">
    <mat-icon>close</mat-icon>
  </div>
</div>
<div class="dialog-content">
  <div class="dialog-form scroll-content-padding df-c gap25" autocomplete="off">
    <div class="df gap20">
      <range-date-picker valueType="month"
        style="width: 160px; min-width: 160px; max-width: 160px;"
        [appearance]="'outline'"
        [label]="'modules.clients.associations.uploadApartmentsDialog.labels.period'"
        [(ngModel)]="period"
        [minDate]="minDate"
      >
      </range-date-picker>

      <mat-form-field appearance="outline" floatLabel="always" class="no-padding" style="width: 140px; min-width: 140px; max-width: 140px;">
        <mat-label>Дата документа</mat-label>
        <input matInput [matDatepicker]="documentDate" [(ngModel)]="date">
        <mat-datepicker-toggle matSuffix [for]="documentDate"></mat-datepicker-toggle>
        <mat-datepicker #documentDate></mat-datepicker>
      </mat-form-field>

      <mat-form-field appearance="outline" floatLabel="always" class="no-padding" style="width: 170px; min-width: 170px; flex: 1 0 170px">
        <mat-label>{{ 'modules.billing.agreements.agreementDialog.labels.number' | translate }}</mat-label>
        <input type="text" matInput [(ngModel)]="document.number">
      </mat-form-field>
    </div>

      <div class="df fFlex jc-e ai-e">
          <span class="add-row" (click)="addRow()">Додати послугу</span>
      </div>

    <span class="hint">Без переліку послуг документ рахується за договором; щойно додано хоч один рядок — це документ на додаткові послуги.</span>

    <ng-container *ngFor="let service of document.services; let i = index">
      <div class="df-c gap10">
        <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width">
          <mat-label>Назва послуги</mat-label>
          <input type="text" required matInput [(ngModel)]="document.services![i].name">
        </mat-form-field>
        <div class="df gap10 jc-s ai-c">
          <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 120px; min-width: 120px; max-width: 120px">
            <mat-label>{{'modules.billing.agreements.agreementDialog.labels.quantity' | translate}}</mat-label>
            <input type="number" required matInput step=".01" [(ngModel)]="document.services![i].qty">
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 120px; min-width: 120px; max-width: 120px">
            <mat-label>{{'Од. вим.'}}</mat-label>
            <input type="text" required matInput [(ngModel)]="document.services![i].unit">
          </mat-form-field>

          <mat-form-field appearance="outline" floatLabel="always" class="no-padding full-width" style="width: 120px; min-width: 120px; max-width: 120px">
            <mat-label>{{'modules.billing.agreements.agreementDialog.labels.price' | translate}}</mat-label>
            <input type="number" required matInput step=".01" [(ngModel)]="document.services![i].price">
          </mat-form-field>

          <div>{{countAmount(service.qty, service.price) | currency:'UAH':'грн.':'0.2-2'}}</div>

          <div class="df jc-c ai-c">
            <button class="delete-form-control-button" (click)="deleteRow(i)">
              <mat-icon>delete_outline</mat-icon>
            </button>
          </div>
        </div>

        <mat-divider class="grow"></mat-divider>
      </div>
    </ng-container>

    <mat-form-field appearance="outline" class="no-padding full-width" floatLabel="always">
      <mat-label>Коментар</mat-label>
      <textarea cdkTextareaAutosize cdkAutosizeMinRows="2" cdkAutosizeMaxRows="20" matInput type="text" [(ngModel)]="document.comment"></textarea>
    </mat-form-field>

    <div class="df-c jc-c ai-c" *ngIf="isInvoice()">
      <mat-checkbox [formControl]="send">{{ 'modules.billing.bills.addBillDialog.labels.send' | translate }}</mat-checkbox>
    </div>

    <div class="df-c jc-c ai-c" *ngIf="canChooseVat()">
      <mat-checkbox [formControl]="vat">З ПДВ</mat-checkbox>
    </div>
  </div>
</div>

<div class="buttons-row df jc-sb ai-c">
  <b class="fFlex" *ngIf="document.services?.length">{{getTotal() | currency:'UAH':'грн.':'0.2-2'}}</b>
  <button class="default-button apply-button" [disabled]="(loading$ | async) == true" (click)="submitForm()">
    {{ 'common.addItem' | translate }}
  </button>
</div>
